<div class="">
  <span [ngClass]="{'marginTop' : isBuyerinfo}">{{ translateToggleFieldName(fieldObject) }}</span>
  <mat-radio-group [ngClass]="{'col-lg-12' : isBuyerinfo}" [formControl]="formControlRef" aria-label="Select an option">
    <mat-radio-button [value]="true" class="mx-3">{{'Sellers.Products.Yes' | translate}}</mat-radio-button>
    <mat-radio-button [value]="false">{{'Sellers.Products.No' | translate}}</mat-radio-button>
  </mat-radio-group>
</div>
